/**
 * Fixed Header with headroom.js
 * @dependencies headroom.js
 */

import Headroom from 'headroom.js';

// Header Element
const navConcessionnaire = document.querySelector('.js-nav-concessionnaire')
const nav = document.querySelector('.js-fixed-nav');
const topHeader = document.querySelector('.js-topheader');
const branding = document.querySelector('.js-fixed-branding');

const offset = topHeader.offsetHeight + branding.offsetHeight + nav.offsetHeight;

// Headroom Options
const fixedNav = new Headroom(nav, {
  offset : offset,
  classes : {
    // when element is initialised
    initial : "initialized",
    // when scrolling up
    pinned : "is-pinned",
    // when scrolling down
    unpinned : "is-unpinned",
    // when above offset
    top : "is-top",
    // when below offset
    notTop : "is-not-top",
    // when at bottom of scoll area
    bottom : "is-bottom",
    // when not at bottom of scroll area
    notBottom : "is-not-bottom"
  }
});

// Headroom Options
const fixedBranding = new Headroom(branding, {
  offset : topHeader.offsetHeight,
  classes : {
    // when element is initialised
    initial : "initialized",
    // when scrolling up
    pinned : "is-pinned",
    // when scrolling down
    unpinned : "is-unpinned",
    // when above offset
    top : "is-top",
    // when below offset
    notTop : "is-not-top",
    // when at bottom of scoll area
    bottom : "is-bottom",
    // when not at bottom of scroll area
    notBottom : "is-not-bottom"
  }
});

if (navConcessionnaire && Foundation.MediaQuery.is('large up')) {

  const offset = window.scrollY + navConcessionnaire.getBoundingClientRect().top
  const fixedNavConcessionaire = new Headroom(navConcessionnaire, {
    offset,
    classes : {
      // when element is initialised
      initial : "initialized",
      // when scrolling up
      pinned : "is-pinned",
      // when scrolling down
      unpinned : "is-unpinned",
      // when above offset
      top : "is-top",
      // when below offset
      notTop : "is-not-top",
      // when at bottom of scoll area
      bottom : "is-bottom",
      // when not at bottom of scroll area
      notBottom : "is-not-bottom"
    }
  })
  fixedNavConcessionaire.init()
} else {
  if (Foundation.MediaQuery.is('large up')) {
    fixedNav.init();
  } else {
    fixedBranding.init();
  }
}





